import { useState } from 'react';
import { useApp } from '../../../context/AppContext';

//import tags
import { Link, useLocation } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

//import resources
import { FaFacebookF, FaInstagram, FaPhone, FaEnvelope, FaBars, FaTimes, FaPlus } from "react-icons/fa";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Nav({locale}) {

    const { categories, contact } = useApp();
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    //get locale
    const { t } = useTranslation();

    //get current page
    const location = useLocation();
    const currentPath = location.pathname;

    const pathSegments = currentPath.split("/").filter(Boolean);
    pathSegments.shift();
    const newPath = `/${pathSegments.join("/")}`;


    return (
        <>
            <div className='border-t border-b border-gray-200 px-3'>
                <div className='container mx-auto'>
                    <div className='grid grid-cols-12 gap-4'>
                        <div className='col-span-6 md:col-span-10 lg:col-span-9 mainNavigation'>
                            <nav className="flex gap-2">
                                {
                                    categories === null ? 
                                        <>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                        </>
                                    :
                                    (
                                        typeof categories === 'object' && categories !== null ? (
                                            categories.data.slice(0, 3).map((item, index) => (
                                                <div key={item.id} className="relative group">
                                                    <Link 
                                                        to={`/${locale}/products/${item.slug || ""}`} 
                                                        className={`${index === 0 ? 'px-0' : 'px-1 2xl:px-4'} text-[11px] xl:text-[12px] 2xl:text-[13px] hover:text-[var(--orange)] py-5 block`}
                                                    >
                                                        {item.translations[0]?.name}
                                                    </Link>
            
                                                    
                                                    <ul className="absolute left-0 hidden group-hover:flex bg-white shadow-lg border p-4 gap-4 w-auto z-20">
                                                        {Array.from({ length: Math.ceil(item.descendants.length / 10) }).map((_, colIndex) => (
                                                            <div key={colIndex} className="flex flex-col">
                                                                {item.descendants.slice(colIndex * 10, colIndex * 10 + (colIndex < 3 ? 10 : 8)).map((descendant) => (
                                                                    <li key={descendant.id} className="py-1">
                                                                        <Link to={`/${locale}/products/${descendant.slug || ""}`} className="block px-2 hover:text-[var(--orange)] text-[12px] whitespace-nowrap">
                                                                            {descendant.name}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </ul>
            
                                                </div>
                                            ))
                                        ) : null
                                    )
                                }

                                <Link to={`/${locale}/products/outlet`} className="px-1 2xl:px-4 py-5 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('authlet')}</Link>
                                <Link to={`/${locale}/products/weekly-promotion`} className="px-1 2xl:px-4 py-5 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('week_promo')}</Link>
                                <Link to="https://calc.planetarium.ge/?fbclid=IwAR1HJyKZAHwHBvCXBuDJHuAab-jxVXPdDft-OB-wAaeG_VXmztMjq14PPZ8" className="px-1 2xl:px-4 py-5 block text-[11px] xl:text-[12px] 2xl:text-[13px]">
                                    {t('what_i_ll_see')}
                                </Link>
                                <Link to={`/${locale}/news`} className="px-1 2xl:px-4 py-5 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('news')}</Link>
                            </nav>

                        </div>
                        <div className='col-span-6 lg:col-span-9 mobileNavigation py-3'>
                            <div onClick={()=>setShowMobileMenu(true)}>
                                <FaBars size='26' />
                            </div>
                        </div>
                        <div className='col-span-6 lg:col-span-3'>
                            <div className='h-full flex items-center justify-end'>
                                <Link to={`/ka${newPath}`} className='align-middle inline-block cursor-pointer'>KA</Link>
                                <span className='ms-1 me-1 border-l border-gray-300 align-middle w-[2px] h-[20px] inline-block cursor-pointer'></span>
                                <Link to={`/en${newPath}`} className='align-middle inline-block cursor-pointer me-4'>EN</Link>
                                <span className='socials'>
                                    <Link className='flex items-center justify-center w-full h-full' to={contact?.data?.fb} target='_blank'><FaFacebookF /></Link>
                                </span>
                                <span className='socials'>
                                    <Link className='flex items-center justify-center w-full h-full' to={contact?.data?.instagram} target='_blank'><FaInstagram /></Link>
                                </span>
                                <span className='socials'>
                                    <Link className='flex items-center justify-center w-full h-full' to={`tel: ${contact?.data?.phone ? (contact?.data?.phone).split('|')[0] : ''}`} target='_blank'><FaPhone /></Link>
                                </span>
                                <span className='socials'>
                                    <Link className='flex items-center justify-center w-full h-full' to={`mailto: ${contact?.data?.email}`} target='_blank'><FaEnvelope /></Link>
                                </span>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
            </div>
            {
                showMobileMenu ? 
                    <div className='fixed top-0 left-0 w-screen h-screen bg-black/60 backdrop-blur-sm z-40 block lg:hidden'>
                        <div className={`absolute top-0 left-0 w-[300px] h-screen bg-white z-20 transition-transform duration-[3000ms] transform ${showMobileMenu ? 'translate-x-0' : '-translate-x-full'}`}>
                            <div className='bg-gray-100 py-4 px-3 font-bold'>{t('categories')}</div>
                            <div className='absolute top-0 right-0 w-[35px] h-[35px] bg-white flex items-center justify-center rounded-full mt-2 me-2 cursor-pointer' onClick={()=>setShowMobileMenu(false)}>
                                <FaTimes />
                            </div>
                            <nav className="gap-2 px-3">
                                {
                                    categories === null ? 
                                        <>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                            <span className='py-4'><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                                        </>
                                    :
                                    (
                                        typeof categories === 'object' && categories !== null ? (
                                            categories.data.slice(0, 3).map((item, index) => (
                                                <div key={item.id} className="relative group">
                                                    <Link 
                                                        className={`${index === 0 ? 'px-0' : 'px-1 2xl:px-4'} flex justify-between text-[11px] xl:text-[12px] 2xl:text-[13px] hover:text-[var(--orange)] py-3 block`}
                                                    >
                                                        {item.translations[0]?.name}
                                                        <FaPlus />
                                                    </Link>
            
                                                    
                                                    <ul className="hidden group-hover:flex bg-gray-100 p-4 gap-4 w-auto z-20">
                                                        {Array.from({ length: Math.ceil(item.descendants.length / 10) }).map((_, colIndex) => (
                                                            <div key={colIndex} className="flex flex-col">
                                                                {item.descendants.slice(colIndex * 10, colIndex * 10 + (colIndex < 3 ? 10 : 8)).map((descendant) => (
                                                                    <li key={descendant.id} className="py-1">
                                                                        <Link to={`/${locale}/products/${descendant.slug || ""}`} className="block px-2 hover:text-[var(--orange)] text-[12px] whitespace-nowrap">
                                                                            {descendant.name}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </ul>
            
                                                </div>
                                            ))
                                        ) : null
                                    )
                                }

                                <Link to={`/${locale}/products/outlet`} className="px-1 2xl:px-4 py-3 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('authlet')}</Link>
                                <Link to={`/${locale}/products/weekly-promotion`} className="px-1 2xl:px-4 py-3 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('week_promo')}</Link>
                                <Link to="https://calc.planetarium.ge/?fbclid=IwAR1HJyKZAHwHBvCXBuDJHuAab-jxVXPdDft-OB-wAaeG_VXmztMjq14PPZ8" className="px-1 2xl:px-4 py-3 block text-[11px] xl:text-[12px] 2xl:text-[13px]">
                                    {t('what_i_ll_see')}
                                </Link>
                                <Link to={`/${locale}/news`} className="px-1 2xl:px-4 py-3 block text-[11px] xl:text-[12px] 2xl:text-[13px]">{t('news')}</Link>
                            </nav>
                        </div>
                    </div>
                :
                ''
            }
            
        </>
        
    );
}